import Toast from '@/h5/components/toast'
import { ref, onMounted, reactive, watch } from 'vue'
import { customRequest, baseSecret } from '@/h5/api/activity'
import { randomNum, getTimestamp, getSignedData } from '@/packages/plugins/utils'
import LGSdk from '@/packages/plugins/languageSDK/index'

export const TIPS_EVENTS = [
  {
    name: 'showTips',
    label: '显示物品提示',
    params: [
      {
        label: '物品id',
        value: 'id'
      },
      {
        label: '物品价值',
        value: 'value'
      },
      {
        label: '物品价值类型',
        value: 'valueType'
      },
      {
        label: '物品图片地址',
        value: 'picUrl'
      },
      {
        label: '有效期',
        value: 'expireTime'
      }
    ]
  },
  {
    name: 'hiddenTips',
    label: '隐藏物品提示'
  }
]

export const TIPS_DATA_SOURCE = []

export const API = {
  /**
   * 获取物品配置
   * @param {*} id
   * @returns
   */
  getActivityConfig: async (id) => {
    const params = {
      propIds: id,
      sign: '',
      appId: 1004,
      random: randomNum(6),
      timestamp: getTimestamp()
    }
    params.sign = getSignedData(params, baseSecret)
    return customRequest(null, '/v1/prop-mall/ids', 'get', {}, params)
  },
  /**
   * 获取分类信息
   * @param {*} id
   * @returns
   */
  getTagInfo: async (id) => {
    const params = {
      tagId: id,
      appId: 1004,
      timestamp: getTimestamp(),
      random: randomNum(6),
      sign: '',
      categorys: 5
    }
    params.sign = getSignedData(params, baseSecret)
    return customRequest(null, '/v1/prop-mall-tag', 'get', {}, params)
  }
}

export const useTips = (props, initTipsFunc) => {
  const componentRef = ref(null)

  const state = reactive({
    // 语言
    language: 'en',
    // 组件uuid
    uuid: '',
    // 配置
    tipsCfg: {}
  })

  const initTips = () => {
    try {
      if (state.tipsCfg?.id) {
        // 初始化-获取当前语言对应的信息
        if (state.language !== 'en') {
          state.tipsCfg.name = state.tipsCfg.names[state.language] || ''
          state.tipsCfg.introduction = state.tipsCfg.introductions[state.language] || ''
          state.tipsCfg.cover = state.tipsCfg.covers[state.language] || ''
        }
        initTipsFunc && initTipsFunc(state.tipsCfg, state.language)
      }
    } catch (e) {
      console.error(e)
      Toast && Toast({ message: LGSdk.t('tips.initFail'), duration: 1500 })
    }
  }

  // 显示tips
  const showTips = async (params) => {
    const id = params.id
    if (!id) {
      // TODO: 多语言翻译
      Toast && Toast({ message: LGSdk.t('tips.lackId'), duration: 1500 })
    }
    const res = await API.getActivityConfig(id)
    state.tipsCfg = res?.data?.list[0] || {}
    if (!state.tipsCfg?.id) {
      Toast && Toast({ message: LGSdk.t('tips.getDataFail'), duration: 1500 })
    }
    if (params.value && params.valueType) {
      state.tipsCfg.goodsValue = params.value
      state.tipsCfg.goodsValueType = params.valueType
    }
    if (params.picUrl) {
      state.tipsCfg.picUrl = params.picUrl
    }
    if (params.expireTime) {
      state.tipsCfg.expireTime = params.expireTime
    }
    initTips()
  }

  // 编辑器初始化
  const getConfig = async () => {
    if (props.activityId) {
      const res = await API.getActivityConfig(props.activityId)
      state.tipsCfg = res?.data?.list[0] || {}
      if (!state.tipsCfg?.id) {
        Toast && Toast({ message: LGSdk.t('tips.getDataFail'), duration: 1500 })
      }
      initTips()
      return res.data?.list[0] || null
    }
  }

  onMounted(() => {
    if (componentRef.value) {
      const language = componentRef.value.getAttribute('language')
      state.language = language ? (language === 'zh' ? 'zh-Hans' : language) : 'en'
      state.uuid = componentRef.value.getAttribute('id') || ''
    }
    if (import.meta.env.VITE_APP_TAG !== 'H5') {
      // 非H5环境，直接获取配置
      getConfig()
    }
  })

  watch(
    () => props,
    () => initTips(),
    {
      immediate: true,
      deep: true
    }
  )

  return {
    componentRef,
    getConfig,
    showTips
  }
}
